import request from '@/util/request'
import { game, mycard } from '@/proto/payload.js'

// 获取游戏列表
export function gameList() {
    return request({
        url: '/v1/game/list',
        method: 'GET',
        resType: game.GameListResponse
    })
}

// 获取区服列表
export function serverList(data) {
    return request({
        url: '/game/web/serverList',
        method: 'GET',
        data
    })
}

// 获取角色列表
export function roleList(data) {
    return request({
        url: '/game/web/roleList',
        method: 'POST',
        data
    })
}

// 获取商品列表
export function shopList(data) {
    return request({
        url: '/game/web/productList',
        method: 'POST',
        data
    })
}


// 获取充值記錄
export function orderList(data) {
    return request({
        url: '/game/web/orderList',
        method: 'POST',
        data
    })
}

// 下单
export function order(data) {
    return request({
        url: '/web/order/mycard/createOrder',
        method: 'POST',
        data
    })
}


// 获取订单状态
export function cheackOrder(data) {
    return request({
        url: '/web/order/mycard/checkOrder',
        method: 'POST',
        data
    })
}

// 通知订单状态
export function orderStatus(data) {
    return request({
        url: '/web/order/paypal/complete',
        method: 'POST',
        data
    })
}